import React from 'react';
import { WorkflowDashboardMetrics } from '../types';

interface Props {
  metrics: WorkflowDashboardMetrics | null;
}

export const WorkflowMetricsCards: React.FC<Props> = ({ metrics }) => {
  if (!metrics) return null;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Active Workflows</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>{metrics.activeWorkflows}</span>
        <span className="stat-sub">Orchestrating domain states</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Pending Tasks</span>
        <span className="stat-value" style={{ color: '#d97706' }}>{metrics.pendingTasks}</span>
        <span className="stat-sub">{metrics.overdueTasks} overdue</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Pending Approvals</span>
        <span className="stat-value" style={{ color: '#7c3aed' }}>{metrics.pendingApprovals}</span>
        <span className="stat-sub">Sequential / SoD Gates</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Completed Today</span>
        <span className="stat-value" style={{ color: '#059669' }}>{metrics.completedToday}</span>
        <span className="stat-sub">{metrics.completedThisWeek} this week</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Failed / Suspended</span>
        <span className="stat-value" style={{ color: '#dc2626' }}>
          {metrics.failedWorkflows + metrics.suspendedWorkflows}
        </span>
        <span className="stat-sub">Requires intervention</span>
      </div>
    </div>
  );
};
